import { render, staticRenderFns } from "./NewsWidget.vue?vue&type=template&id=e4167b34&scoped=true"
import script from "./NewsWidget.vue?vue&type=script&lang=js"
export * from "./NewsWidget.vue?vue&type=script&lang=js"
import style0 from "./NewsWidget.vue?vue&type=style&index=0&id=e4167b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4167b34",
  null
  
)

export default component.exports